"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../Buttons/Button/index.js");
const NonIdealState_js_1 = require("./NonIdealState.js");
const itwinui_illustrations_react_1 = require("@itwin/itwinui-illustrations-react");
/**
 * @deprecated Use `NonIdealState` instead for a smaller client bundle.
 *
 * A stylized display to communicate common http errors.
 * @example
 * <ErrorPage errorType='401' />
 */
const ErrorPage = (props) => {
    const { errorType, errorName, errorMessage, primaryButtonHandle, primaryButtonLabel, secondaryButtonHandle, secondaryButtonLabel, translatedErrorMessages, ...rest } = props;
    const defaultErrorMessages = {
        badGateway: 'Bad gateway',
        error: 'Error',
        forbidden: 'Forbidden',
        internalServerError: 'Internal server error',
        redirect: 'Redirect',
        pageNotFound: 'Page not found',
        serviceUnavailable: 'Service unavailable',
        timedOut: 'Timed out',
        unauthorized: 'Unauthorized',
        ...translatedErrorMessages,
    };
    function getErrorIcon() {
        switch (errorType) {
            case '300':
            case '301':
            case '302':
            case '303':
            case '304':
            case '305':
            case '307':
            case '308': {
                return React.createElement(itwinui_illustrations_react_1.SvgRedirect, null);
            }
            case '401': {
                return React.createElement(itwinui_illustrations_react_1.Svg401, null);
            }
            case '403': {
                return React.createElement(itwinui_illustrations_react_1.Svg403, null);
            }
            case '404': {
                return React.createElement(itwinui_illustrations_react_1.Svg404, null);
            }
            case '408':
            case '504': {
                return React.createElement(itwinui_illustrations_react_1.SvgTimedOut, null);
            }
            case '500': {
                return React.createElement(itwinui_illustrations_react_1.Svg500, null);
            }
            case '502': {
                return React.createElement(itwinui_illustrations_react_1.Svg502, null);
            }
            case '503': {
                return React.createElement(itwinui_illustrations_react_1.Svg503, null);
            }
            case 'generic':
            default: {
                return React.createElement(itwinui_illustrations_react_1.SvgError, null);
            }
        }
    }
    function getHeadingMessage() {
        if (errorName) {
            return errorName;
        }
        switch (errorType) {
            case '300':
            case '301':
            case '302':
            case '303':
            case '304':
            case '305':
            case '307':
            case '308': {
                return defaultErrorMessages.redirect || '';
            }
            case '401': {
                return defaultErrorMessages.unauthorized;
            }
            case '403': {
                return defaultErrorMessages.forbidden;
            }
            case '404': {
                return defaultErrorMessages.pageNotFound;
            }
            case '408':
            case '504': {
                return defaultErrorMessages.timedOut || '';
            }
            case '500': {
                return defaultErrorMessages.internalServerError;
            }
            case '502': {
                return defaultErrorMessages.badGateway;
            }
            case '503': {
                return defaultErrorMessages.serviceUnavailable;
            }
            case 'generic':
            default: {
                return defaultErrorMessages.error;
            }
        }
    }
    function getPrimaryButton() {
        if (!primaryButtonHandle || !primaryButtonLabel) {
            return undefined;
        }
        return (React.createElement(index_js_1.Button, { styleType: 'high-visibility', onClick: primaryButtonHandle }, primaryButtonLabel));
    }
    function getSecondaryButton() {
        if (!secondaryButtonHandle || !secondaryButtonLabel) {
            return undefined;
        }
        return (React.createElement(index_js_1.Button, { styleType: 'default', onClick: secondaryButtonHandle }, secondaryButtonLabel));
    }
    function getActions() {
        const primaryButton = getPrimaryButton();
        const secondaryButton = getSecondaryButton();
        if (!primaryButton && !secondaryButton) {
            return undefined;
        }
        return (React.createElement(React.Fragment, null,
            primaryButton,
            secondaryButton));
    }
    return (React.createElement(NonIdealState_js_1.NonIdealState, { svg: getErrorIcon(), heading: getHeadingMessage(), description: errorMessage, actions: getActions(), ...rest }));
};
exports.ErrorPage = ErrorPage;
exports.default = exports.ErrorPage;
